import { Card, Flex, Space, Typography } from 'antd';
import classes from './SelectInput.module.scss';
import { DownOutlined } from '@ant-design/icons';
import React, { forwardRef } from 'react';
import { CardComponent } from 'shared/ui';
import { useSelector } from 'react-redux';
import { getAccountCards } from 'shared/config/store/reducers/cardsSlice';
import { getCurrentEmi } from 'shared/config/store/selectors/app';
import { getAccounts } from 'shared/config/store/selectors/account';
import { getLinearGradientString } from 'shared/libs/utils/helpers';
import { getSpendableBalance } from 'shared/libs/utils/balance';
import { COLORS } from 'shared/const/theme';

const { Text } = Typography;

type Props = {
  selectedAccount: string;
  className?: string;
};

const SelectInput: React.FC<Props> = ({ selectedAccount, className }) => {
  const emi = useSelector(getCurrentEmi);
  const selectedAccountObject = useSelector(getAccounts)[selectedAccount];

  // TODO: filter and check if card is active or other conditions
  const accountCards = useSelector(getAccountCards(emi, Number(selectedAccount)));

  return (
    <Card
      className={`${classes['card']}${className ? ' ' + classes[className] : ''}`}>
      <Flex justify="space-between" align="center">
        <Flex vertical gap={4}>
          <Text className={classes['card__subtitle']}>{selectedAccountObject.iban}</Text>
          <Text className={classes['card__amount']}>
            {getSpendableBalance(selectedAccountObject.available).toFixed(2)} €
          </Text>
        </Flex>
        <Flex gap={16} align="center">
          {accountCards.length !== 0 && (
            <CardComponent
              size="m"
              status={accountCards[0].status}
              shortNumber={accountCards[0].numberMasked.slice(-4)}
              bgColor={getLinearGradientString([COLORS.PRIMARY, COLORS.PRIMARY])}
            />
          )}
          <DownOutlined
            style={{
              color: '#00000099',
              fontSize: 16,
            }}
          />
        </Flex>
      </Flex>
    </Card>
  );
};

export default SelectInput;
